class WorkflowLayoutUtil {
  public static calculateDropdownTop(
    initialTop: number,
    menuHeight: number,
    topMargin: number = 16,
    viewportHeight?: number,
  ): number {
    const _viewportHeight = viewportHeight ?? window.innerHeight;
    let top = initialTop;

    if (top + menuHeight > _viewportHeight - topMargin) {
      top = Math.max(_viewportHeight - menuHeight - topMargin, topMargin);
    }
    if (top < topMargin) {
      top = topMargin;
    }

    return top;
  }
}

export default WorkflowLayoutUtil;


